
import { AuxOtpText, OtpBtn, OtpBtnContainer } from "Auth/pages/ReceiveOtp/Styles";

import { OtpContainer } from "Pricing/Single/Styles";
import { pricingOBJ } from "Pricing/pricingClass";
import { useEffect, useState } from "react";

import { OTPInput, Spinner } from "shared/components";
import Modal from "shared/quickComponents/modal";
import {  getStoreLocalStorage } from "shared/utils/authToken";
import Gateway from "./Gateway";
import AgencyBanking from "./AgencyBanking";
import { FormTitle, PriceFormContainer, SubTitle, Title } from "Pricing/Styles";

const CreatePrice=()=>{
    const [application, setApplication] = useState("");


    useEffect(()=>{
        const app=getStoreLocalStorage("application");
        setApplication(app)
    }, []);
    return(
        <>
            <PriceFormContainer>
                {application=="Gateway" && <Gateway title={"Add a new price"}  pageAction={"CREATE"} />}
                {application=="Agency Banking" && <AgencyBanking />}
            </PriceFormContainer>
            
        </>
    )
}

export default CreatePrice;